import { FC } from "react";
import { Product } from "~/entities/product/types";

const ProductLinked: FC<{ product: Product }> = ({ product }) => {
  if (product.linkedProducts.length < 1) return null;

  return (
    <div className="flex w-full max-w-screen-sm flex-col gap-2">
      {product.linkedProducts.map((prodLink, i) => (
        <div
          key={i}
          className="flex w-full rounded border border-blue700 font-sans text-sm font-semibold uppercase"
        >
          <p className="product-linked__message flex grow items-center justify-center text-center">
            {prodLink.text}
          </p>
          <a
            role="button"
            href={prodLink.url}
            className="product-linked__button bg-blue750 p-2 uppercase text-white"
          >
            Show me the {prodLink.styleCode}
          </a>
        </div>
      ))}
    </div>
  );
};

export default ProductLinked;
